// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__layout,#__nuxt,body{height:100vh}.white .image-bg{background:#ccc;background-size:cover;position:fixed;top:0;bottom:0;left:0;right:0;transform:scale(1.1);-moz-filter:blur(5px);-o-filter:blur(5px);-ms-filter:blur(5px);filter:blur(5px);z-index:-1}.logo-container{position:fixed;left:0;top:0;opacity:1;padding:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
